import { AuthSecrets, AuthSettings, TestResult } from "./generalType";
import { EMPTY_SETTINGS, NO_SECRETS } from "./authSettingsLogic";

export interface AuthSettingsState {
    readonly model: {
        readonly settings: AuthSettings;
        readonly secrets: AuthSecrets;
    };
    readonly view: {
        /** False until the first GET answered; the form stays hidden until then. */
        readonly loaded: boolean;
        readonly loadFailed: boolean;
        readonly saving: boolean;
        /** Messages of the last refused save (HTTP 400). */
        readonly errors: readonly string[];
        readonly ldapTest: TestResult;
        readonly keycloakTest: TestResult;
    };
}

export const AuthSettingsInitialState: AuthSettingsState = {
    model: {
        settings: EMPTY_SETTINGS,
        secrets: NO_SECRETS,
    },
    view: {
        loaded: false,
        loadFailed: false,
        saving: false,
        errors: [],
        ldapTest: { kind: "idle" },
        keycloakTest: { kind: "idle" },
    },
};
